import React, { useEffect } from 'react';
import { connect } from "react-redux";
import './DlUnitEdit.scss';
import { getUnit, saveUnit } from "./../../actions";
import FileUpload from './FileUpload';
import StatFileLink from '../StatFileLink';
import DlUnit from '../../models/DlUnit';
import DlUnitSingleNav from './DlUnitSingleNav';


const mapStateToProps = (state) => ({
  dlUnitId: state.dlUnit.dlUnitId,
    dlUnit: state.dlUnit.dlUnit
});
  
const mapDispatchToProps = (dispatch) => ({
  getUnit: (id) => dispatch(getUnit(id)),
  saveUnit: (payload) => dispatch(saveUnit(payload)),
});

const DlUnitPdfUpd = ({ match, getUnit, saveUnit, dlUnit, dlUnitId }) => {
  const itemId = ( 'itemId' in match.params ? match.params.itemId : '' );
  useEffect(function() {
    if (itemId!=='') {
      getUnit(itemId);
    }  
  }, [itemId]);

  let pdf = dlUnit.hasOwnProperty('pdf') && dlUnit.pdf !== '' ? dlUnit.pdf : { nam: '', fold: 'dl-unit/mat/' + (new Date()).getFullYear()};

  const saveItem = () => {
    let item = new DlUnit();
    item.obSet(dlUnit);
    item.pdf = pdf;
    saveUnit({ itemId, item });
  }

  const pdfUpAfter = (res) => {
    res = JSON.parse(res);
    pdf.nam = res.files[0]['filename'];
    // console.log(pdf);
    // console.log(res);
  };

  const pdfUpOpt = {
    upFoldPath: 'up/' + pdf.fold + '/',
    upOnSel: true,
  };

  const pdfLinkP = ( pdf.nam != '' ? <StatFileLink fold={ pdf.fold } fNam={ pdf.nam } nam={ pdf.nam } /> : null );

  return (
    <div>
      <DlUnitSingleNav item={ dlUnit } />
      <div style={{ marginTop: '1em' }}>
          { pdfLinkP } 
      </div>        
      <div style={{ marginTop: '0.5em' }}>
          <FileUpload fOpt={ pdfUpOpt } fUpAfter={ pdfUpAfter } />
      </div>      
      <div className="a-save-p">
          <button onClick={()=>saveItem()}>OK</button>
      </div>
    </div>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitPdfUpd);
